export class ShipmentIdCheck {
  receiverName: string
  idNum: string

  constructor(receiverName: string, idNum: string) {
    this.receiverName = receiverName
    this.idNum = idNum
  }
}
